( function () {
  if ( typeof wp === 'undefined' || !wp.hooks?.addAction ) {
    return;
  }

  wp.hooks.addAction(
    'b3rg_embedded_form_marketo_form_load_event',
    'berg/marketo-data-layer',
    function () {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push( { event: 'marketo-demo-form-submit' } );
    }
  );
}() );
